import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { DialogService } from '../dialog/dialog.service';
import { EVSidebarService } from './ev-sidebar.service';
import { SidebarMode } from './ev-sidebarMode.enum';

@Component({
  selector: 'app-ev-sidebar',
  templateUrl: './ev-sidebar.component.html',
  styleUrls: ['./ev-sidebar.component.scss'],
  standalone: true,
  imports: [],
})
export class EvSidebarComponent {
  public readonly SIDEBAR_MODES = SidebarMode;
  public activeOption: SidebarMode = null;
  public subscriptions: Array<Subscription> = new Array<Subscription>();

  constructor(private readonly dialogService: DialogService, private readonly sidebarService: EVSidebarService) {
    this.subscriptions.push(
      this.sidebarService.sidepanelModeChange().subscribe((option: SidebarMode) => {
        this.activeOption = option;
      }),
    );
  }

  public setActive(option: SidebarMode) {
    if (option === this.activeOption) {
      this.sidebarService.clearSidebarMode();
    } else {
      this.sidebarService.setSidebarMode(option);
    }
  }

  public helpDialog(): void {
    this.dialogService.openHelpDialog();
  }
  public contactDialog(): void {
    this.dialogService.openContactDialog();
    this.sidebarService.clearSidebarMode();
  }
}
